import React, { useEffect, useState } from "react";
import "./Modal.css";
import  Cookies from "js-cookie";
import { softDelete } from "../network/api/user.js";
import * as main_category from "../network/api/maincategory.js";
import { useNavigate } from "react-router-dom";



const Modall = React.memo((props) => {
  const navigate = useNavigate();
  const [Error,setError]=useState("")
  const [id, setid] = useState("");
  useEffect(() => {
    main_category
      .getcategories()
      .then((result) => {
        const firstId = result?.data?.response?.[0]?._id;
        if (firstId) setid(firstId);
      })
      .catch(() => {
        // no-op
      });
  }, []);
  const  comfirmSoftDelete = async() => {
    const response=await softDelete()
    if(response.data.success){
      Cookies.remove("user");
      Cookies.remove("mycart");
      Cookies.remove("mywish");
      props.onClose();
      navigate("/");
      window.location.reload();
      
    }
    setError("something went wrong")
    
  };
  return (
    <React.Fragment>
      <div className="backdrop"/>
        <div style={{ textAlign: "center" }} className="error-modal">
          <h4 style={{color:"#3d3729"}}>Are u Sure you want to delete account</h4>
          <p>{props.children}</p>
          <div className=" d-flex justify-content-center p-2 ">
            <button
              className=" btn ms-2 d-none d-sm-none d-lg-block "
              style={{ backgroundColor: "#d99d2b" }}
              type="button"
              onClick={()=>{
                props.onClose()
                props?.setTabChosen("user")
              }}
            >
              Cancel
            </button>

            {/* small screen only  */}
            <button
              className=" btn ms-2 d-block d-lg-none"
              style={{ backgroundColor: "#d99d2b" }}
              type="button"
              onClick={()=>{
                navigate("/profile")
              }}
            >
              Cancel
            </button>
            <button
              className=" btn "
              style={{ backgroundColor: "#d99d2b" }}
              type="button"
              onClick={comfirmSoftDelete}
            >
              Okay
            </button>
          </div>
          {Error && (
            <div className="alert alert-danger" role="alert">
              {Error}
            </div>
          )}
        </div>
      
    
    </React.Fragment>
  );
});

export default Modall;
